// 한글 이름을 기반으로 영문 slug를 생성하는 함수
export const nameToSlug = (name) => {
  if (!name) return '';
  return name.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
};
